import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmComponent } from '../Components/confirm-dialog/confirm.component';
import { ConfirmDialogData } from '../Models/ConfirmDialogData';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { defaults } from '../../app.config';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  constructor(private dialog: MatDialog, private translateService: TranslateService) { }

  confirmDialog(data: ConfirmDialogData): Observable<boolean> {
    if (data.titleKey) {
      this.translateService.get(data.titleKey).subscribe((translation: any) => {
        data.title = translation;
      });
    }

    this.translateService.get(data.messageKey).subscribe((translation: any) => {
      data.message = translation;
    });

    this.translateService
      .get(data.confirmTextKey)
      .subscribe((translation: any) => {
        data.confirmText = translation;
      });
    // Updated By Youssef Yahya
    if (data.cancelTextKey) {
      this.translateService
        .get(data.cancelTextKey)
        .subscribe((translation: any) => {
          data.cancelText = translation;
        });
    }
    return this.dialog
      .open(ConfirmComponent, {
        data,
        disableClose: true,
      })
      .afterClosed();
  }

  openDialog(Component?: any, data?: any) {
    return this.dialog.open(Component, {
      data,
      direction: defaults.dir
    });
  }
}
